@if (Globals.domainInfo?.splash) {
  <div class="splash">
    <img [src]="Globals.domainInfo.splash"  alt="" />
  </div>
}

<div class="form-wrapper">
  <div class="register-wrapper">
    <div class="register-options card-like">
      <h1 class="title">{{ 'registerwith' | translate:{value: Globals.domainInfo?.name || Globals.APP_NAME} }}</h1>

      @if (!regular) {
        <div class="social">
          @if (user) {
            <p>
              {{ 'welcome' | translate:{user: (user.salutation ? (user.salutation | translate) + ' ' + user.name_last : user.name_first)} }},
              <br>
                {{ 'responded' | translate }}
              </p>
            }
<!--            <button nbButton size="large" (click)="socialLogin('linkedin')" class="social-button linkedin">-->
<!--              <nb-icon icon="linkedin"></nb-icon><span>{{ 'registerwithlinkedin' | translate }}</span>-->
<!--            </button>-->
<!--            <div class="sep">-->
<!--              <span>{{ 'or' | translate }}</span>-->
<!--            </div>-->
            <button nbButton size="large" (click)="socialLogin('google')" class="social-button google">
              <nb-icon pack="custom-icons" icon="google"></nb-icon><span>{{ 'registerwithgoogle' | translate }}</span>
            </button>
            <div class="sep">
              <span>{{ 'or' | translate }}</span>
            </div>
            <button nbButton size="large" (click)="regularLogin()" class="social-button regular">
              <nb-icon icon="email"></nb-icon><span>{{ 'registerwithusername' | translate }}</span>
            </button>
          </div>
        }

        @if (regular) {
          <div class="regular">
            <h3>
              <nb-icon icon="bulb"></nb-icon><span>{{ 'enteremailtostart' | translate }}</span>
            </h3>
            @if (form) {
              <form [formGroup]="form">
                <input nbInput type="hidden" formControlName="with">
                <div class="inputs">
                  <div class="input-group">
                    <div>
                      <label>{{ 'email' | translate }}</label>
                      <input nbInput formControlName="username" fullWidth type="email" maxlength="100" [placeholder]="'enterusername' | translate">
                    </div>
                  </div>
                  <div class="input-group">
                    <div>
                      <label>{{ 'password' | translate }}</label>
                      <bst-password [fullWidth]="true" [placeholder]="'enterpassword' | translate" formControlName="password" ></bst-password>
                    </div>
                  </div>
                </div>
                <div class="buttons">
                  <button nbButton type="button" (click)="regularLogin()">
                    <nb-icon icon="arrow-left"></nb-icon>
                    <span>{{ 'back' | translate }}</span>
                  </button>
                  <button nbButton type="submit" [bstErroring]="form" (bstErroringSuccess)="submit()" status="primary">
                    <nb-icon icon="checkmark"></nb-icon>
                    <span>{{ 'createaccount' | translate }}</span>
                  </button>
                </div>
              </form>
            }
          </div>
        }

        <div class="terms">
          {{ 'terms.1' | translate }}
          <a href="assets/files/flix_it_terms_of_service.pdf" target="_blank">{{ 'termsconditions' | translate }}</a>
          {{ 'terms.2' | translate }}
          <a href="assets/files/flix_it_privacy_policy.pdf" target="_blank">{{ 'privacypolicy' | translate }}</a>{{ 'terms.3' | translate }}
        </div>
      </div>

      <div class="already">
        <a [routerLink]="'/login'" [queryParams]="{with: this.id}">{{ 'alreadyregistered' | translate }}</a>
      </div>
    </div>
  </div>
